module.exports = __webpack_public_path__ + "img/HeartBeat.5779c2ff.svg";